<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Faça o login!</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="email"
                label="E-mail"
                name="login"
                prepend-icon="mdi-account"
                type="text"
              ></v-text-field>

              <v-text-field
                v-model="password"
                id="password"
                label="Senha"
                name="password"
                prepend-icon="mdi-lock"
                type="password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="submit" color="primary" v-on:click="login">Entrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <notifications group="userNotFound" position="bottom center" :speed="500" />
  </v-container>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import router from "../router";
import EventBus from "./EventBus";

export default {
  data() {
    return {
      email: "",
      password: "",
    };
  },

  methods: {
    login() {
      axios
        .post("https://www.sabios.net.br/api/usuario/login", {
          email: this.email,
          password: this.password,
        })
        .then((res) => {
          if (!res.data.match("ERRO")) {
            localStorage.setItem("usertoken", res.data);
            this.email = "";
            this.password = "";
            if (res) {
              this.emitMethod();
              router.push({ path: "/tutorial" }).catch(()=>{});
            }
          } else {
            this.$notify({
              group: "userNotFound",
              title: res.data.replace("ERRO: ", ""),
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            group: "userNotFound",
            title: "Usuário não existe!",
            type: "error",
          });
        });
    },
    emitMethod() {
      EventBus.$emit("logged-in", "loggedin");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue